import { Create, SimpleForm, useStore } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import CreateSaveForm from "./CreateSaveForm";

const STORE_KEY = "foreignLanguagesSchedule.filters";

const CreateForeignLanguagesSchedules = () => {
  const [savedFilters] = useStore(STORE_KEY);

  const { academicSessionType, ...initialValues } = savedFilters || {};
  const hasSavedFilters = Object.keys(initialValues).length > 0;

  return (
    <Create
      title="Създаване на разписания за чужди езици"
      actions={<BackButtonToolbar />}
      transform={data => {
        const { academicYearId, structuralUnitId, instructionLanguageId, studyTypeId, ...payload } = data;
        return payload;
      }}
    >
      <SimpleForm defaultValues={initialValues}>
        <CreateSaveForm hasSavedFilters={hasSavedFilters} />
      </SimpleForm>
    </Create>
  );
};

export default CreateForeignLanguagesSchedules;
